import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import scaylorOrb from '../assets/images/ScaylorOrbB.svg';
import curvedWisp from '../assets/images/Background Curve Wisp.png';
import bluePinkGradient from '../assets/images/bluePnkGradient.svg';
import pinkRedGradient from '../assets/images/pinkRedGradient.svg';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Attempting to register with:', formData);

    try {
      // First try to login - if this succeeds, the user exists
      const loginResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (loginResponse.ok) {
        // User exists, get their token
        const { token } = await loginResponse.json();
        localStorage.setItem('token', token);

        // Check if they have a profile
        const userResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });

        if (userResponse.ok) {
          const userData = await userResponse.json();
          if (userData.name) {
            // They have a profile, check organization
            const orgResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/organization`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
              }
            });

            if (orgResponse.ok) {
              const orgData = await orgResponse.json();
              if (orgData.organization) {
                navigate('/'); // They have everything, go to main page
              } else {
                navigate('/organization-setup'); // Need organization setup
              }
            } else {
              navigate('/organization-setup');
            }
          } else {
            navigate('/profile-setup'); // Need profile setup
          }
        } else {
          navigate('/profile-setup'); // Assume they need profile setup
        }
        return;
      }

      // If login failed, try to register them
      const registerResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (registerResponse.ok) {
        // Registration successful, now login to get token
        const loginAfterRegisterResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (loginAfterRegisterResponse.ok) {
          const { token } = await loginAfterRegisterResponse.json();
          localStorage.setItem('token', token);
          navigate('/profile-setup'); // New user needs to set up profile
        } else {
          console.error('Auto-login failed after registration');
          navigate('/login');
        }
      } else {
        const error = await registerResponse.json();
        console.error('Registration failed:', error);
        alert('Registration failed: ' + (error.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Registration error:', error);
      alert('Network error: ' + error.message);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="h-screen flex items-start justify-center pt-24 overflow-hidden relative">
      {/* Background Wisp */}
      <div className="absolute bottom-0 left-0">
        <img 
          src={bluePinkGradient} 
          alt="Blue Pink Gradient" 
          className="w-[800px] opacity-500"
        />
      </div>

      {/*bluePinkGradient*/}
      <div className="absolute top-0 left-0">
        <img 
          src={curvedWisp} 
          alt="Background Wisp" 
          className="w-[300px] opacity-100"
        />
      </div>

      {/*pinkRedGradient*/}
      <div className="absolute top-0 right-0">
        <img 
          src={pinkRedGradient} 
          alt="Pink Red Gradient" 
          className="w-[700px] opacity-100"
        />
      </div>

      {/* Orb Background */}
      <div className="absolute inset-0 flex items-start justify-center pt-[4%]">
        <img 
          src={scaylorOrb} 
          alt="Scaylor Orb" 
          className="w-[800px] opacity-50"
        />
      </div>

      {/* Register Form - Glass Effect */}
      <div className="bg-white/10 backdrop-blur-md rounded-3xl p-44 py-[125px] w-[650px] shadow-lg z-10 relative mt-[5%]">
        <div className="flex flex-col items-center">
          <h1 className="text-7xl font-bold font-montserrat text-shadow-custom -mt-24 mb-6">SCAYLOR</h1>
        </div>
        
        <h2 className="text-2xl mb-6 font-Gilroy font-bold">Sign Up</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm mb-2 font-Gilroy font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="username@gmail.com"
              className="w-full px-3 py-2 border rounded-lg"
              required
            />
          </div>

          <div>
            <label className="block text-sm mb-2 font-Gilroy font-medium">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              className="w-full px-3 py-2 border rounded-lg"
              required
            />
          </div>

          <div className="text-right">
            <a href="#forgot" className="text-sm text-gray-600 hover:underline">
              Forgot Password?
            </a>
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800 font-Gilroy font-bold"
            
          >
            
            Sign Up
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-gray-600">
          Already have an account?{' '}
          <span
            onClick={() => navigate('/login')}
            className="text-blue-600 cursor-pointer hover:underline"
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
};

export default Register; 